<template>
  <h3>Accessibility Preferences</h3>
  <accessibility-settings/>
</template>

<script lang="ts">
import AccessibilitySettings from "control-panel/components/accessibilitysettings/AccessibilitySettings.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { AccessibilitySettings },
});
</script>
